import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { withRouter } from "react-router-dom";

import './styles.scss';

class SuggestionList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      start:true,
      end:false,
      totalSpace: 0,
      carouselRef: ''
    };
    this.offset = 160;
    this.suggestionList = props.list;
  }

  componentDidMount() {
    const 
      carouselRef = document.querySelector('.suggestion-carousel'),
      sliderRef = document.querySelector('.suggestion-slider'),
      totalSpace = sliderRef.offsetWidth - carouselRef.offsetWidth;
    this.setState({ ...this.state, totalSpace: totalSpace, carouselRef:carouselRef });
  }

  updateSliderStatus() {
    if (this.state.carouselRef.scrollLeft >= this.state.totalSpace) {
      this.state.end = true;
    } else {
      this.state.end = false;
    }

    if (this.state.carouselRef.scrollLeft === 0) {
      this.setState({ ...this.state, start: true});
    } else {
      this.setState({ ...this.state, start: false});
    }
  };
  
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  
  async sideScroll(element, rangeInPixels) {
    if (element) {
      if (rangeInPixels > 0) {
        for (let i = 0; i < rangeInPixels; i++) {
          await this.sleep(5);
          element.scrollLeft+=5;
        }
      } else {
        for (let i = 0; i < -rangeInPixels; i++) {
          await this.sleep(5);
          element.scrollLeft-=5;
        }
      }
    }
  }

  handlePrevEvent() {
    this.sideScroll(this.state.carouselRef, -50);
  };

  handleNextEvent() {
    this.sideScroll(this.state.carouselRef, 50);
  };

  render() {
    return(
      <div 
        className="suggestion-carousel-container"
      >
        <div className="suggestion-carousel" onScroll={() => this.updateSliderStatus()}>
          <ul className="suggestion-slider">
            {this.suggestionList.map((row, index) => {
              return (
                <li key={index} className="suggestion-iten">
                  <span
                    name="form-field-name"
                    onClick={(e) =>this.props.sendMessage(e.target.innerText, 'TEXT', '')}
                  >
                      {row}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="controls">
           <div 
            className="arrow prev" 
            style={this.state.start ? {display: 'none'} : {display: 'flex'}} 
            onClick={() => this.handlePrevEvent()}
           >
              <FiChevronLeft/>
            </div>
           <div 
            className="arrow next"
            style={this.state.end ? {display: 'none'} : {display: 'flex'}}
            onClick={() => this.handleNextEvent()}
           >
             <FiChevronRight/>
           </div>
         </div>
        </div>
    )
  }
}

export default withRouter(SuggestionList);